import React, { Component } from "react";

import AOS from "aos";

import Footer from "./common/Footer";

class Locations extends Component {
  renderTemplate = (locationId, templateID) => {
    this.props.history.push(`location/${locationId}/${templateID}/menu`);
  };

  componentDidMount = () => {
    AOS.init();
  };

  render() {
    return (
      <div className="locationsContainer">
        <div className="container-fluid" id="locationHeader">
          <h1 className="text-center">Bowinkles Drive Thru</h1>
        </div>
        <div className="container-fluid" id="pushTop">
          <div className="textHeader text-center">
            <h1>Please Choose a Location</h1>
            <div className="row justify-content-center">
              <div
                className="col-md-5 riolinda"
                data-aos="fade-right"
                onClick={() => this.renderTemplate("Rio-Linda", 1)}
              >
                <div className="overlay">
                  <div className="content">
                    <h2 style={{ color: "#DD0606", fontSize: "34px" }}>
                      Rio Linda Location
                    </h2>
                  </div>
                </div>
              </div>
              <div
                className="col-md-5 rancho"
                data-aos="fade-left"
                onClick={() => this.renderTemplate("Rancho-Cordova", 2)}
              >
                <div className="overlay">
                  <div className="content">
                    <h2 style={{ color: "#DD0606", fontSize: "34px" }}>
                      Rancho Cordova Location
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Locations;
